document.addEventListener("DOMContentLoaded", function () {
  if (!window.IS_WHOLESALE) return;

  function hideBuyNowButtons(root = document) {
    root.querySelectorAll("shopify-buy-it-now-button")
      .forEach(el => el.style.display = "none");
  }

  hideBuyNowButtons();

  const observer = new MutationObserver(mutations => {
    for (const m of mutations) {
      m.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        if (node.tagName === "SHOPIFY-BUY-IT-NOW-BUTTON") {
          node.style.display = "none";
        } else {
          hideBuyNowButtons(node);
        }
      });
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  const checkoutBtn = document.getElementById("checkout");

    if (checkoutBtn) {
      checkoutBtn.addEventListener("click", function (e) {
        // first time
        setTimeout(() => {
          const textToRemoves = document.querySelectorAll('.bss-modal-qi.active li.bss-qi-text-warning')
          textToRemoves.forEach(textToRemove => {
            let html = textToRemove.innerHTML;
            html = html.replace(/the multiple of(?:<\/?[^>]+>)*\s*\d+,\s*(?:<\/?[^>]+>)*and\s*/gi, '');
            textToRemove.innerHTML = html;
          });

          document.querySelectorAll('.bss-qi-text-warning').forEach(el => {
            el.innerHTML = el.innerHTML.replace(/,\s*<span class="bss-b2b-translation-qi-validate_max_message_text"[\s\S]*?\d+/, '');
          });
        }, 300);

        setTimeout(() => {
          const observer = new MutationObserver((MutationList) => {
            for (let item of MutationList) {
              if (item.target.classList?.contains('bss-qi-list-product-warning-qty')) {
                console.log('123123123')
                const textToRemoves = document.querySelectorAll('.bss-modal-qi.active li.bss-qi-text-warning')
                textToRemoves.forEach(textToRemove => {
                  let html = textToRemove.innerHTML;
                  html = html.replace(/the multiple of(?:<\/?[^>]+>)*\s*\d+,\s*(?:<\/?[^>]+>)*and\s*/gi, '');
                  textToRemove.innerHTML = html;
                });

                document.querySelectorAll('.bss-qi-text-warning').forEach(el => {
                  el.innerHTML = el.innerHTML.replace(/,\s*<span class="bss-b2b-translation-qi-validate_max_message_text"[\s\S]*?\d+/, '');
                });
              }
            }
          });

          observer.observe(document.body, {
            childList: true,
            subtree: true
          });
        }, 300);
    });
  }
});


